import {SearchableItemService} from "../../../services/SearchableItemService";
import {textFilterParamsValues} from "../reactTableController";

export const defaultSortModel = [
    {
        colId: 'accountNumber',
        sort: 'asc',
        sortIndex: 0
    }
];
export const predefinedDefaultSortModel = [
    {
        colId: 'bank',
        sort: 'asc',
        sortIndex: 0
    }
];
export const predefinedNonMovSortModel = [
    {
        colId: 'lastStatementDate',
        sort: 'asc',
        sortIndex: 0
    }
];
export const reactAccountCols = function ( translate, userService, hideFilters) {
    const filterFormatter = userService.filterFormatter;
    const nineHundredths = new Date(1900, 0, 1, 1, 0, 0, 0).getTime();
    return [ {
        field: "shortName",
        headerName: translate.instant('ACCOUNT_NAME'),
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: textFilterParamsValues
    },{
        field: "accountNumber",
        headerName: translate.instant('ACCOUNT_NUMBER'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "userDefinedAlias1",
        headerName: translate.instant('ACCOUNT_ALIAS'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "bank",
        headerName: translate.instant('BANK'),
        sortable: true,
        filter: hideFilters.indexOf('bank') !== -1 ? false : "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['bank'])
                    .then(data => params.success(data.map(it => it.name)));
            }}
    }, {
        field: "bic",
        headerName: translate.instant('BIC'),
        sortable: true,
        filter: 'agSetColumnFilter',
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['bic'])
                    .then(data => params.success(data.map(it => it.code)));
            }}
    },{
        field: "countryName",
        headerName: translate.instant('COUNTRY'),
        sortable: true,
        filter:  hideFilters.indexOf('country') !== -1 ? false : "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['country'])
                    .then(data => params.success(data.map(it => it.name)));
            }}
    },{
        field: "currencyCode",
        headerName: translate.instant('CURRENCY'),
        sortable: true,
        filter:  hideFilters.indexOf('currency') !== -1 ? false : "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['currency'])
                    .then(data => params.success(data.map(it => it.code)));
            }}
    },{
        field: "balance",
        headerName: translate.instant('BALANCE_ACC'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.balance.amount, params.data.balance.fractionDigits) : "";
        },
        type: 'numericColumn'
    },{
        field: "consolidatedBalance",
        headerName: translate.instant('BALANCE_CONS'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.consolidatedBalance.amount, params.data.consolidatedBalance.fractionDigits) : "";
        },
        type: 'numericColumn'
    },{
        field: "lastMT940Date",
        headerName: translate.instant('LAST_MT940_DATE'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateTimeNoLocal')( params.data.lastMT940Date) : "";
        },
        initialHide: true
    },{
        field: "lastMT942Date",
        headerName: translate.instant('LAST_MT942_DATE'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data && params.data.lastMT942Date !== nineHundredths ?
                filterFormatter('fsDateTimeNoLocal')( params.data.lastMT942Date) : "";
        },
        initialHide: true
    }];
}
